import { render, staticRenderFns } from "./DossierEditQuickCreateCopySelectTargetDossier.vue?vue&type=template&id=408c5e9e&"
import script from "./DossierEditQuickCreateCopySelectTargetDossier.vue?vue&type=script&lang=ts&"
export * from "./DossierEditQuickCreateCopySelectTargetDossier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408c5e9e')) {
      api.createRecord('408c5e9e', component.options)
    } else {
      api.reload('408c5e9e', component.options)
    }
    module.hot.accept("./DossierEditQuickCreateCopySelectTargetDossier.vue?vue&type=template&id=408c5e9e&", function () {
      api.rerender('408c5e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierEditQuickCreateCopySelectTargetDossier.vue"
export default component.exports